import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "sg-app" }

import Toolbar from '@/components/toolbar/Toolbar.vue';
import Notifications from '@/components/notification/Notifications.vue';
import SGIcon from '@/components/sgicon/SGIcon.vue';
import Version from '@/components/version/Version.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'SoesahGamingApp',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Notifications),
    _createElementVNode("header", null, [
      _createElementVNode("h1", null, [
        _createVNode(SGIcon),
        _createTextVNode(" Soesah Gaming ")
      ]),
      _createVNode(Toolbar)
    ]),
    _createElementVNode("main", null, [
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("footer", null, [
      _createTextVNode(" Carl Giesberts - 2018 - "),
      _createVNode(Version)
    ])
  ]))
}
}

})